import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const todayDate = (): string => {
  const today = new Date();
  const dd = String(today.getDate()).padStart(2, "0");
  const mm = String(today.getMonth() + 1).padStart(2, "0");
  const yyyy = today.getFullYear();

  return `${mm}-${dd}-${yyyy}`;
}

export const formatDate = (date: string): string => {
  const [mm, dd, yyyy] = date.split("-");
  return `${mm}-${dd}-${yyyy}`;
}